import { render, staticRenderFns } from "./AdminAdd.vue?vue&type=template&id=98166474&scoped=true"
import script from "./AdminAdd.vue?vue&type=script&lang=js"
export * from "./AdminAdd.vue?vue&type=script&lang=js"
import style0 from "./AdminAdd.vue?vue&type=style&index=0&id=98166474&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98166474",
  null
  
)

export default component.exports